// /src/hooks/useAutoReload.js
import { useEffect, useState } from "react";

const useAutoReload = (intervalMs = 60 * 60 * 1000) => {
    const [dateLoaded, setDateLoaded] = useState(null);

    useEffect(() => {
        const handleReload = () => {
            const now = new Date();
            const dd = String(now.getDate()).padStart(2, "0");
            const mm = String(now.getMonth() + 1).padStart(2, "0");
            const hrs = now.getHours();
            const mins = now.getMinutes();
            const yyyy = now.getFullYear();
            const today = mins + mm + "/" + dd + "/" + yyyy;

            if (!dateLoaded) {
                setDateLoaded(today);
            } else if (dateLoaded !== today && hrs > 2) {
                window.location.reload(true);
            }
        };

        const id = setInterval(handleReload, intervalMs);
        return () => clearInterval(id);
    }, [dateLoaded, intervalMs]);
};

export default useAutoReload;
